import { createFileRoute } from '@tanstack/react-router';
import { PrestacaoModule } from '@/mobile/modulos/prestacao/PrestacaoModule';

export const Route = createFileRoute('/m/prestacao')({
  component: PrestacaoModule,
});
